/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Search, Label } from 'semantic-ui-react';
import _ from 'lodash';
import './googleAddressAutocomplete.styles.less';
import { injectIntl } from 'react-intl';

class GoogleAddressAutocomplete extends Component {

  onItemSelected = null;
  onGetGoordinatesFailed = null;
  googleAutocompleeteService = null;
  geocoderService = null;
  GOOGLE_API_SCRIPT_ID = 'googleApiScript';

  constructor(props) {
    super(props);
    this.onItemSelected = this.props.onItemSelected;
    this.onGetGoordinatesFailed = this.props.onGetGoordinatesFailed;
  }

  state = {
    isLoading: false,
    results: [],
    value: '',
    latitude: null,
    longitude: null,
    sessionToken: null,
    isGoogleLibLoaded: false
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ value: nextProps.value });
  }

  componentWillMount() {
    const existingScript = document.getElementById(this.GOOGLE_API_SCRIPT_ID);
    if (!existingScript) {
      const script = document.createElement('script');
      script.async = true;
      script.onload = this.onGoogleMapInit;
      script.id = this.GOOGLE_API_SCRIPT_ID;
      script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${this.props.googleApiKey}`;
      document.head.appendChild(script);
    } else if (!this.googleAutocompleeteService) {
      this.onGoogleMapInit();
    }
    this.resetComponent();
  }

  onGoogleMapInit = () => {
    this.googleAutocompleeteService = new google.maps.places.AutocompleteService();
    this.geocoderService = new google.maps.Geocoder();
    this.setState({ isGoogleLibLoaded: true });
  }

  resetComponent = () => this.setState({ isLoading: false, results: [], value: '' });

  handleResultSelect = (e, { result }) => {

    this.geocoderService.geocode({ placeId: result.place_id }, (geocodingResults, status) => {
      if (status === 'OK' && geocodingResults.length) {
        const location = geocodingResults[0].geometry.location;
        const locationData = { value: result.title, latitude: location.lat(), longitude: location.lng() };
        this.setState({ ...locationData, results: [], sessionToken: null }, this.onItemSelected(locationData));
      } else {
        if (this.onGetGoordinatesFailed) {
          this.onGetGoordinatesFailed(status, geocodingResults);
        } else {
          console.log('Address was not determined by place_Id: ', result.place_id, 'Status: ', status, 'Results: ', geocodingResults);
        }
      }
    });
  };

  handleSearchChange = (e, { value }) => {

    const sessionToken = this.state.sessionToken || new google.maps.places.AutocompleteSessionToken();
    this.setState({ isLoading: true, value, sessionToken });

    if (!value.length > 0) {
      this.setState({ isLoading: false, results: [] });
      return;
    }

    if (this.state.isLoading) {
      return;
    }

    // https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service
    const request = { input: value };
    this.googleAutocompleeteService.getPlacePredictions(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.setState({
          isLoading: false,
          results: results.map((v) => ({ id: v.id, title: v.description, place_id: v.place_id }))
        });
      }
    }
    );
  };

  render() {
    if (!this.state.isGoogleLibLoaded) {
      return null;
    }

    const { isLoading, value, results } = this.state;
    let { resultItemRenderer } = this.props;
    const { className, icon, intl } = this.props;

    if (!resultItemRenderer) {
      resultItemRenderer = (item) => <Label className="autocomplete-item" key={item.place_id} content={item.title} />;
    }
    return (
      <Search
        className={`google-autocomplete ${className}`}
        loading={isLoading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={_.debounce(this.handleSearchChange, 600, {
          leading: true
        })}
        results={results}
        value={value}
        resultRenderer={resultItemRenderer}
        icon={icon || {}}
        showNoResults={false}
        minCharacters={2}
        placeholder={intl.formatMessage({ id: 'google.autocomplete.address.placeholder' })}
      />
    );
  }
}

GoogleAddressAutocomplete.propTypes = {
  googleApiKey: PropTypes.string,
  resultItemRenderer: PropTypes.func,
  onItemSelected: PropTypes.func.isRequired,
  onGetGoordinatesFailed: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.string,
  intl: PropTypes.object,
  value: PropTypes.string
};

export default injectIntl(GoogleAddressAutocomplete);
